<template>
    <!-- 返回顶部 -->
      <div class="go-top"
      :class="classList"
      v-show="isShow">
      <div class="top" @click="toGotop">
        <svg class="icon-svg collect-icon" aria-hidden="true">
          <use xlink:href="#icon-search_top"></use>
        </svg>
        <span>顶部</span>
      </div>
      <!-- isHaierApp && -->
      <!-- <div class="divider" v-if="isHaierApp && feedShow"></div>
      <div class="bottom" v-if="isHaierApp && feedShow" @click="toFeedBack()">
        <img :src="`${$cdnImageUrl}/common/common-edit-icon.png`" />
        <span>反馈</span>
      </div> -->
      <!-- <div class="divider" v-if="serviceShow"></div>
      <div class="bottom service" v-if="serviceShow" @click="toService()">
        <img :src="`${$cdnImageUrl}/common/common-service-icon.png`" />
        <span>客服</span>
      </div> -->
    </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: () => { return false }
    },
    // fromTitle: {
    //   type: String,
    //   default: () => { return '' }
    // },
    classList: {
      type: Object,
      default: () => { return {} }
    },
    feedShow: {
      type: Boolean,
      default: () => { return true }
    },
    // serviceShow: {
    //   type: Boolean,
    //   default: () => { return true }
    // },
    code: {
      type: Number,
      default: () => { return null }
    },
  },
  data() {
    return {
      isHaierApp: false, // 验证是否智家app内
      timer: null, // 计时器
    }
  },
  created() {
    this.isHaierApp = this.$util.isUplus()
  },
  watch: {
    isShow: {
      handler (newVal) {
        console.log(newVal)
        console.log('this.timer:', this.timer)
        if (newVal) {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          } else {
            this.timer = setTimeout(() => {
              this.hiddenFeedBack()
            }, 4000);
          }
        } else {
          clearTimeout(this.timer)
          this.timer = null
        }
      },
      // immediate: true,
    },
  },
  methods: {
    /**
     * 隐藏 FeedBack
     */
    hiddenFeedBack() {
      console.log('hiddenFeedBack')
      this.$emit('hiddenFeedBack')
    },
    /**
     * 返回顶部
     */
    toGotop() {
      this.$emit('toTop')
    },
    // /**
    //  * @description 跳平台客服
    // */
    // toService() {
    //   this.$router.push({ path: '/customerService',
    //     query: {
    //       accountId: 'zhijiashop',
    //       fromPageUrl: document.URL,
    //       fromPageTitle: this.fromTitle
    //     }
    //   })
    // },
    /**
     * 跳转反馈页
    */
    toFeedBack() {
      // 验证登录
      if (this.$store.getters.getLoginStatus) {
        let url = 'https://uplus.haier.com/uplusapp/problemFeedBack/feedback.html'
        if (this.code) {
          url = 'https://uplus.haier.com/uplusapp/problemFeedBack/feedback.html?code=' + this.code
        }
        this.$util.openNewWindow(url, true, false, false)
      } else {
        this.$store.dispatch('doLogin').then(res => {
          if (res === 400) {
            console.log('请求异常')
          }
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.go-top{
  position: fixed;
  left: 50%;
  // bottom: 1.48rem;
  bottom: 3.16rem;
  width: 0.92rem;
  // height: 2.08rem;
  display: flex;
  transform: translateX(123px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: .26rem 0;
  color: #333333;
  line-height: .2rem;
  font-size: .2rem;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  background: #ffffff;
  border: .02rem solid #d9d9d9;
  border-radius: 1rem;
  z-index: 99;
  svg{
    width: .36rem;
    height: .36rem;
  }
  .divider{
    width: .68rem;
    height: 0.02rem;
    background-color: #efefef;
    margin: .14rem 0;
  }
  span{
    margin-top: .08rem;
  }
  .top,.bottom,service{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
}
// .go-top.top-margin-no-sale{
//   bottom: calc(1.48rem + 0.88rem + constant(safe-area-inset-bottom));
//   bottom: calc(1.48rem + 0.88rem + env(safe-area-inset-bottom));
// }
// .go-top.has-bottom-bar{
//   bottom: calc(1.48rem + constant(safe-area-inset-bottom));
//   bottom: calc(1.48rem + env(safe-area-inset-bottom));
// }
/* 多规格弹窗底部适配 iphonex */
// @supports (bottom: env(safe-area-inset-bottom)) {
//  .go-top {
//    bottom: calc(2.8rem + constant(safe-area-inset-bottom));
//    bottom: calc(2.8rem + env(safe-area-inset-bottom));
//  }
// }
</style>
